import React from 'react'
import { BigButton } from '../../../../../components/button'
import { Box, Boxes } from '../../../layout/box'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import withSafeCharge from './hocs/safecharge'
import Paying from '../components/loading/paying'
import { FormattedMessage } from 'react-intl'
import AskMask from '../components/ask-mask'

const CardBody = withSafeCharge(props => {

    useStyles(classes)

    const {
        handleSubmit,
        submiting,
        cardError,
        cvvError,
        expiryError,
        children,
        refs,
        showNew
    } = props


    return <>
        <form onSubmit={handleSubmit}>
            {
                showNew && <Boxes>
                    <Box className={classes.CreditBody}>
                        <div className={classes.CardContainer}>
                            <div className={classes.CardHolder}>
                                <label className={classes.Label}>*<FormattedMessage id="card_number" defaultMessage={'Card NUmber'}/></label>
                                <div id="card-number" className="input" ref={refs.cardNumberRef}></div>
                                <div className={classes.Error}>
                                    {cardError}
                                </div>
                            </div>

                            <div className={classes.MultiHolders}>

                                <div className={classes.CardHolder}>
                                    <label className={classes.Label}>*<FormattedMessage id="expiration_date" defaultMessage={'Expiration_date'}/></label>
                                    <div id="card-expiry" className="input empty" ref={refs.expiryRef}></div>
                                    <div className={classes.Error}>
                                        {expiryError}
                                    </div>
                                </div>

                                <div className={classes.CardHolder}>
                                    <label className={classes.Label}>
                                        *Cvv
                                    </label>
                                    <div id="card-cvc" className="input empty" ref={refs.cvvRef}></div>
                                    <div className={classes.Error}>{cvvError}</div>
                                </div>

                            </div>
                        </div>
                    </Box>
                </Boxes>
            }

            {
                children
            }
            <div className={classes.PayBtn}>
                <BigButton loading={submiting} type="submit"><FormattedMessage id="pay_now" defaultMessage={'Pay Now'}/></BigButton>
            </div>
        </form>
        {
            submiting && <Paying/>
        }
    </>
})

export default CardBody